import { render, staticRenderFns } from "./star-filled.vue?vue&type=template&id=79a42790&scoped=true&"
import script from "./star-filled.vue?vue&type=script&lang=js&"
export * from "./star-filled.vue?vue&type=script&lang=js&"
import style0 from "./star-filled.vue?vue&type=style&index=0&id=79a42790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a42790",
  null
  
)

export default component.exports